import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetSuppliersQuery } from '../../store/api/supplierApi';
import { useGetProductsUnderReOrderLevelQuery } from '../../store/api/productsApi';
import { useGetOrderProductsQuery, useGetRequestedProductByCurrentMonthQuery } from '../../store/api/orderProductApi';
import { useGetMovementsQuery } from '../../store/api/movementApi';


const Dashboard = () => {
  const [suppliers, setSuppliers] = useState([])
  const [underLevel, setUnderLevels] = useState([])
  const [movement, setMovement] = useState([])
  const [unrecievedPurchaese, setRecieved] = useState([])
  const [monthlyRequest, setMonthlyRequest] = useState([])

  const { data } = useGetSuppliersQuery()

  const { data: monthlyRequestes } = useGetRequestedProductByCurrentMonthQuery();

  const { data: levels, refetch : refetchUnderLevel  } = useGetProductsUnderReOrderLevelQuery();
 
  const {
    data: urecieved,
    refetch: refetchOrderProducts
  } = useGetOrderProductsQuery();

  useEffect(() => {
    if (urecieved) {
      setRecieved(urecieved)
      refetchOrderProducts();
    }
  }, [urecieved])


  useEffect(() => {
    if (data) {
      setSuppliers(data)
    }
  }, [data])

  useEffect(() => {
    if (levels) {
      setUnderLevels(levels);
      refetchUnderLevel();
    }
  }, [levels]);


  // const {
  //   data: ordered,
  // } = useGetOrderProductsQuery()

  // useEffect(() => {
  //   if (ordered) {
  //     setPurchaseProduct(ordered.filter(ordere => ordere.isWaiting === "not waiting any quantities"))
  //   }
  // }, [ordered])

  // useEffect(() => {
  //   if (ordered) {
  //     setPurchaseProductInWaiting(ordered.filter(ordere => ordere.isWaiting === "waiting for quantities" || ordere.isWaiting === "not waiting for any quantity"))
  //   }
  // }, [ordered])



  const { data:movements } = useGetMovementsQuery()

  useEffect(() => {
    if (movements) {
      setMovement(movements)
    }
  }, [movements])




  useEffect(() => {
    if (monthlyRequestes) {
      setMonthlyRequest(monthlyRequestes)
    }
  }, [monthlyRequestes])


  return (
    <>
      <main >
        <div class="content bg-white">
            <div class="row ">
                <div class="col-6 col-xl-4 ">
                    <Link class="block border rounded-1  block-link-shadow text-right text-decoration-none" to="#">
                        <div class="block-content block-content-full">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <i class="si si-users fa-3x text-body-bg-dark"></i>
                            </div>
                            <div class="font-size-h3 font-w600" data-toggle="countTo" >{suppliers.length > 0? suppliers.length : 0}</div>
                            <div class="font-size-sm font-w600 text-uppercase text-muted">Suppliers</div>
                        </div>
                    </Link>
                </div>
                <div class="col-6 col-xl-4 ">
                    <Link class="block border rounded-1  block-link-shadow text-right text-decoration-none" to="#">
                        <div class="block-content block-content-full">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <i class="fa fa-inbox fa-3x text-body-bg-dark"></i>
                            </div>
                            <div class="font-size-h3 font-w600" data-toggle="countTo" >{monthlyRequest.length > 0? monthlyRequest.length : 0}</div>
                            <div class="font-size-sm font-w600 text-uppercase text-muted">Recieved Purchases</div>
                        </div>
                    </Link>
                </div>
                <div class="col-6 col-xl-4 ">
                    <Link class="block border rounded-1  block-link-shadow text-right text-decoration-none" to="#">
                        <div class="block-content block-content-full">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <i class="fa fa-box fa-3x text-body-bg-dark"></i>
                            </div>
                            <div class="font-size-h3 font-w600" data-toggle="countTo" >{unrecievedPurchaese.length > 0? unrecievedPurchaese.length : 0}</div>
                            <div class="font-size-sm font-w600 text-uppercase text-muted">Unrecieved Purchases</div>
                        </div>
                    </Link>
                </div>
                <div class="col-6 col-xl-4 ">
                    <Link class="block border rounded-1  block-link-shadow text-right text-decoration-none" to="#">
                        <div class="block-content block-content-full">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <i class="fa fa-box fa-3x text-body-bg-dark"></i>
                            </div>
                            <div class="font-size-h3 font-w600" data-toggle="countTo" data-speed="1000">{movement.length > 0? movement.length : 0}</div>
                            <div class="font-size-sm font-w600 text-uppercase text-muted">This month's Orders</div>
                        </div>
                    </Link>
                </div>
                <div class="col-6 col-xl-4 ">
                    <Link class="block border rounded-1  block-link-shadow text-right text-decoration-none" to="#">
                        <div class="block-content block-content-full">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <i class="fa fa-inbox fa-3x text-body-bg-dark"></i>
                            </div>
                            <div class="font-size-h3 font-w600" data-toggle="countTo" data-speed="1000">{underLevel.length > 0? underLevel.length : 0}</div>
                            <div class="font-size-sm font-w600 text-uppercase text-muted">reorder level count</div>
                        </div>
                    </Link>
                </div>
                
            </div>
            
        </div>
        </main>
    </>
  );
};

export default Dashboard;
